<template functional>
  <div>
    <a
      href="#"
      @click="$options.show(props)"
      :class="[props.row.totalConsumption >= 0 ? 'Negro' : 'Rojo']"
      >{{ $options.formatMonto(props.row.totalConsumption) }}</a
    >
  </div>
</template>

<script>
//import store from "../../../../store/index";
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperlinkForNfcMovilTotalConsumos",
  show(ops) {
    ops;
    //console.log("hola", ops)
    ops.row.OpenDetailTotalConsumos(ops.row);
    /*
    store.dispatch("getAllCustomer", {
      empresaid: ops.row.Empresaid
    });
    */
  }
};
</script>
<style>
.Negro {
  color: #606266;
}
</style>
